import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueGtag from 'vue-gtag'

Vue.config.productionTip = false

if (process.env.VUE_APP_GA_TRACKING_ID) {
  Vue.use(VueGtag, {
    config: { id: process.env.VUE_APP_GA_TRACKING_ID }
  }, router)
}

window.getCsrfToken = function () { // eslint-disable-line no-unused-vars
  const csrfCookieName = 'csrftoken'
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${csrfCookieName}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
